import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Router from './MainRouter/Router';
function App() {
  return (
    <div className="App">
      <Router/>
    </div>
  );
}

export default App;
